const Dashboard = () =>
  import(/* webpackChunkName: "dashboard" */ '../views/Dashboard.vue')

const DashboardRoute = [
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: {
      requiresAuth: true,
      hiddeMenu: false,
      navBar: false,
      navBarBack: false,
    },
  },
]

export default DashboardRoute
